export const ScreenSharingMode = {
  STANDARD: 'standard',
  MODERATED: 'moderated',
} as const;

export type ScreenSharingMode =
  (typeof ScreenSharingMode)[keyof typeof ScreenSharingMode];
